<template>
    <v-sheet>
        <v-toolbar
            dense
            flat
            color="secondary">
            <v-toolbar-title>{{$t("malfaction_report_by_truck_details")}}</v-toolbar-title>
        </v-toolbar>
        <div v-if="!loading">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-sheet outlined class="ma-4">
                        <v-simple-table dense>
                            <tbody>
                                <tr>
                                    <th>{{$t("plate_number")}}</th>
                                    <td>{{data[0].plate_number}}</td>
                                </tr>
                                <tr>
                                    <th>{{$t("truck_type")}}</th>
                                    <td>{{data[0].truck_type}}</td>
                                </tr>
                                <tr>
                                    <th>{{$t("FAILURES")}}</th>
                                    <td>{{data[0].malfaction}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-simple-table dense>
                <thead>
                    <tr>
                        <th>{{$t("date")}}</th>
                        <th>{{$t("job_number")}}</th>
                        <th>{{$t("desciption")}}</th>
                        <th>{{$t("user")}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in data" :key="i">
                        <td>{{d.date}}</td>
                        <td>{{d.jobcard_number}}</td>
                        <td>{{d.description}}</td>
                        <td>{{d.user}}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
        <div v-else class="pa-4">
            <v-progress-linear
                class="my-4"
                indeterminate
                color="yellow darken-2"
            ></v-progress-linear>
            <div class="text-center">{{$t("please_wait")}}</div>
        </div>
    </v-sheet>
</template>

<script>
import { getMalfactionsReportByTruckDetails } from './../services/reports';
export default {
    name: "MalfactionReportByTruckDetails",
    props: {
        query: Object
    },
    data() {
        return {
            data: [],
            loading: false
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let resp = await getMalfactionsReportByTruckDetails(this.query);
            this.data = resp.data;
            this.loading = false;
        }
    },
    created() {
        this.fetchData();
    }
}
</script>

<style>

</style>